import { Spinner, Flex } from '@chakra-ui/react'

const CellLoading = () => (
  <Flex justifyContent="center" textAlign="center" width="100%">
    <Spinner
      color="green.300"
      marginY={5}
      size="lg"
      emptyColor="gray.100"
      label="Loading..."
    ></Spinner>
  </Flex>
)

export default CellLoading
